/**
 *
 */
(function(window, undefined) {
	"use strict";

	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasNessunRisultatoDrct", ['CONSTANTS', function(CONSTANTS) {
		var link = function (scope, elem, attrs, model) {

		};

		var controller = function($scope, labelSrvc) {
			$scope.msg = labelSrvc.getLabel;
		};

		controller.$inject = ['$scope', 'LabelSrvc'];

		return {
			restrict: "E",
			scope: {
				msgCustom: '@',
				topMargin: '@'
			},
			controller: controller,
			controllerAs: "creasNessunRisultatoCtrl",
			templateUrl: CONSTANTS.BASE_ROOT + "widgets/creasNessunRisultato/creasNessunRisultato.html",
			link: link
		};
	}]);
}(window));


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasNessunRisultato/creasNessunRisultatoDrct.js
// module id = 7
// module chunks = 0 1